import './InBank.css';
import { Bank } from '../Bank/Bank';
import { useLocation, useNavigate } from 'react-router-dom';

// @ts-ignore
export const InBank = () => {
    const navigate = useNavigate();
    let location = useLocation();

    switch (location.pathname) {
        case '/start':
            navigate('/skins');
            break;
        case '/skins':
            navigate('/game');
            break;
        case '/game':
            navigate('/final');
            break;
    }
    const NavTo = () => {
        switch (location.pathname) {
            case '/classic/start':
                navigate('/classic/skins');
                break;
            case '/classic/skins':
                navigate('/classic/game');
                break;
            case '/classic/game':
                navigate('/classic/final');
                break;
        }
    };

    // @ts-ignore
    return (
        <div className="in-bank">
            <div className="in-bank__container">
                <span className="in-bank__put-text">Поставили</span>
                <div className="in-bank__players">
                    <svg className="in-bank__players-svg" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                        <g fill="#F1F1F1">
                            <path d="M21 20.88H3a3 3 0 1 1 0-6h18a3 3 0 1 1 0 6z" opacity=".6" />
                            <circle cx="12" cy="6.88" r="4" />
                            <circle cx="19.5" cy="10.38" r="2.5" opacity=".6" />
                            <circle cx="4.5" cy="10.38" r="2.5" opacity=".6" />
                            <path d="M15 20.88H9a4 4 0 0 1 0-8h6a4 4 0 0 1 0 8z" />
                        </g>
                    </svg>
                    <span className="in-bank__players-text">
                        0 <span>игроков</span>
                    </span>
                </div>
            </div>
            <Bank />
            <div className="in-bank__container">
                <button onClick={NavTo} className="in-bank__button-skins">
                    Выбрать скины
                </button>
                <span className="in-bank__auto-past">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                        <g fill="none" opacity=".6">
                            <circle cx="11.76" cy="11.76" r="9.84" fill="#605F68" />
                            <path
                                fill="#F1F1F1"
                                d="M11.76 10.776a.984.984 0 0 1-.984-.984V5.856a.984.984 0 1 1 1.968 0v3.936c0 .543-.44.984-.984.984z"
                            />
                            <path
                                fill="#F1F1F1"
                                d="M11.76 18.648a6.896 6.896 0 0 1-6.888-6.888 6.9 6.9 0 0 1 2.294-5.132.985.985 0 0 1 1.313 1.465A4.932 4.932 0 0 0 6.84 11.76a4.926 4.926 0 0 0 4.92 4.92 4.926 4.926 0 0 0 4.92-4.92 4.927 4.927 0 0 0-1.63-3.659.985.985 0 0 1 1.316-1.464 6.906 6.906 0 0 1 2.282 5.123 6.896 6.896 0 0 1-6.888 6.888z"
                            />
                        </g>
                    </svg>
                    <span>Автовставки</span>
                </span>
            </div>
        </div>
    );
};
